import { render, staticRenderFns } from "./InviteClientModal.vue?vue&type=template&id=ef1e4ad8&scoped=true"
import script from "./InviteClientModal.vue?vue&type=script&lang=ts"
export * from "./InviteClientModal.vue?vue&type=script&lang=ts"
import style0 from "./InviteClientModal.vue?vue&type=style&index=0&id=ef1e4ad8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef1e4ad8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef1e4ad8')) {
      api.createRecord('ef1e4ad8', component.options)
    } else {
      api.reload('ef1e4ad8', component.options)
    }
    module.hot.accept("./InviteClientModal.vue?vue&type=template&id=ef1e4ad8&scoped=true", function () {
      api.rerender('ef1e4ad8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/accountant/InviteClientModal.vue"
export default component.exports